import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';

import { requestVideoPlayerPause } from 'actions/videoPlayer';
import { LOOM_PROD_URI, LOOM_STAGE_URI, LOOM_URI } from 'constants/routes';

import EmbedTopBarShareButton from './share-button';
import { onOwnerClick, onTitleClick, watchOnLoomClick } from './analytics';
import { limit } from './formatting';

import { EmbedContext } from 'components/embed-video';
import WatchLaterButton from 'components/share-video/watch-later-button';

import './styles.less';

const limitTo20Characters = limit(20);

export default function EmbedTopBar(props) {
  // we check the production Loom URI too because we embed our production
  // videos in various parts of our onboarding experiences
  const fromAnyLoomPage =
    props.fromPublicSharePage ||
    props.parentLocation.indexOf(LOOM_URI) > -1 ||
    props.parentLocation.indexOf(LOOM_PROD_URI) > -1 ||
    props.parentLocation.indexOf(LOOM_STAGE_URI) > -1;

  const dispatch = useDispatch();

  const shareUrl = `${LOOM_URI}/share/${props.videoModel.id}?t=${props.currentTime}`;

  const watchOnLoomBtnClick = props => {
    dispatch(requestVideoPlayerPause());

    watchOnLoomClick(props);
  };

  return (
    <EmbedContext.Consumer>
      {({ hideOwner, hideTitle, hideShare }) => (
        <div
          className={classNames('embed-screen-top-section', {
            'cta-enabled': props.ctaEnabled,
            started: props.hasStarted,
            ended: props.ended,
          })}
        >
          {!hideTitle && (
            <a
              onClick={() => onTitleClick(props)}
              href={shareUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={classNames('title', {
                'cta-enabled': props.ctaEnabled,
              })}
            >
              {props.videoName}
            </a>
          )}
          <div className="sub-title-section">
            {!hideOwner && (
              <>
                <img src={props.pauseScreenAvatar} align="left" />
                <a
                  onClick={() => onOwnerClick(props)}
                  href={shareUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="owner-name"
                >
                  {limitTo20Characters(props.ownerFullname)}
                </a>
              </>
            )}
            {props.loomBrandedPlayer && !fromAnyLoomPage && (
              <a
                onClick={() => watchOnLoomBtnClick(props)}
                href={shareUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={classNames(
                  'watch-on-loom',
                  hideOwner && 'owner-hidden'
                )}
              >
                Watch on Loom
              </a>
            )}
          </div>
          <div className="embed-screen-watch-later-button flex item:center justify:center">
            <WatchLaterButton tooltipTriggerOffset={2} darkMode={true} />
          </div>
          {!hideShare && (
            <EmbedTopBarShareButton
              hasGmailAccount={props.hasGmailAccount}
              videoIsTeamShared={props.videoIsTeamShared}
              currentUserIsOwner={props.currentUserIsOwner}
              video={props.videoModel}
            />
          )}
        </div>
      )}
    </EmbedContext.Consumer>
  );
}
